import type { AudioImageSyncFormat } from '@/formats/UnitParser';
import type { ImageDimensions } from '@/formats/inputSourcesParsers/SourceParser';
import type { Pixel } from '@/data';
import { getAudioData, linearPath } from 'waveform-path';
import type IRenderService from './IRenderService';

export class WaveFormService implements IRenderService<AudioImageSyncFormat> {
  positions: AudioImageSyncFormat;

  // TODO add the
  // synchronization: ???;

  dimensions: ImageDimensions;

  svgImage: string;

  private musicFileURL: string;

  private IMAGE_HEIGHT = 240;

  // depends on PADDING_SHADE in the StavesZones.vue file
  private IMAGE_TOP = 102;

  private SAMPLING = 40;

  constructor(
    musicFileURL: string,
  ) {
    this.musicFileURL = musicFileURL;

    this.positions = {
      'date-x': [{ date: 0, x: 0 }, { date: 1, x: 1 }],
    } as AudioImageSyncFormat;
    this.dimensions = { width: 0 as Pixel, height: 0 as Pixel };
    this.svgImage = '';
  }

  async loadAndRender(): Promise<void> {
    const audioData = await getAudioData(this.musicFileURL);
    const nbSeconds = Math.round(audioData.duration);
    const width = Math.max(1000, nbSeconds * 10);

    this.svgImage = linearPath(audioData, {
      samples: nbSeconds * this.SAMPLING,
      type: 'mirror',
      top: this.IMAGE_TOP,
      height: this.IMAGE_HEIGHT,
      width,
    });

    this.dimensions = {
      width: width as Pixel,
      height: this.IMAGE_HEIGHT as Pixel,
    };

    this.positions = {
      'date-x': [{ date: 0, x: 0 }, { date: nbSeconds, x: width }],
    } as AudioImageSyncFormat;
  }
}
